import React from 'react';
import { FlagImage } from 'react-international-phone';
import { SearchableSelect } from '../SearchableSelect';

export interface CountrySelectOption {
  value: string; // ISO2 code, e.g. "US"
  label: string; // display name, e.g. "United States"
}

export interface CountrySelectFieldProps {
  label?: string;
  required?: boolean;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  items: CountrySelectOption[];
}

// A plain "which country" field (address forms, account forms, etc) sharing
// the same modern flag-list dropdown as the phone field's country-code
// picker (see InternationalContact/CountryDropdown), instead of a second,
// differently-styled native <select>. Built on the shared SearchableSelect
// rather than its own bespoke dropdown.
export const CountrySelectField: React.FC<CountrySelectFieldProps> = ({
  label,
  required,
  placeholder = 'Select country…',
  value,
  onChange,
  items,
}) => {
  const codeToLabel = new Map(items.map((item) => [item.value, item.label]));

  return (
    <SearchableSelect<string>
      label={label}
      required={required}
      placeholder={placeholder}
      options={items.map((item) => item.value)}
      value={value}
      onChange={onChange}
      getOptionLabel={(code) => codeToLabel.get(code) ?? code}
      filterOption={(code, term) => (codeToLabel.get(code) ?? code).toLowerCase().includes(term.toLowerCase())}
      renderOption={(code) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FlagImage iso2={code.toLowerCase()} size="18px" />
          <span>{codeToLabel.get(code) ?? code}</span>
        </div>
      )}
    />
  );
};
